import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=c03a801a"
import script from "./FormText.vue?vue&type=script&lang=ts"
export * from "./FormText.vue?vue&type=script&lang=ts"
import style0 from "./FormText.vue?vue&type=style&index=0&id=c03a801a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports